/*
 * Favourites.
 *
 * Shopify has no native wishlist, so this keeps a list of product handles in
 * the visitor's own browser. It is per-device by design — it will not follow
 * someone to their phone. Swapping this for a wishlist app later means
 * replacing this file and the two snippets that call it, nothing else.
 *
 * Clicks are handled once, at the document, so hearts on cards that arrive
 * after the page loads (recommendations, filtering, sliders) work too; new
 * buttons are painted with their saved state as soon as they appear.
 */
(function () {
  var KEY = 'jo-favorites';

  function read() {
    try {
      var raw = localStorage.getItem(KEY);
      var list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list : [];
    } catch (e) {
      // Private mode, or storage disabled. Behave as if nothing is saved.
      return [];
    }
  }

  function write(list) {
    try {
      localStorage.setItem(KEY, JSON.stringify(list));
    } catch (e) {
      /* nothing we can do; the button just won't persist */
    }
  }

  function has(handle) {
    return read().indexOf(handle) !== -1;
  }

  function toggle(handle) {
    var list = read();
    var i = list.indexOf(handle);
    if (i === -1) list.push(handle);
    else list.splice(i, 1);
    write(list);
    return i === -1;
  }

  function paintButton(btn) {
    var on = has(btn.getAttribute('data-jo-fav'));
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    btn.classList.toggle('is-saved', on);
    var label = btn.querySelector('[data-jo-fav-label]');
    if (label) label.textContent = on ? 'Saved' : 'Add to Favorites';
    else btn.setAttribute('aria-label', on ? 'Remove from favorites' : 'Add to favorites');
  }

  function paintAll(root) {
    (root || document).querySelectorAll('[data-jo-fav]').forEach(paintButton);
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest && event.target.closest('[data-jo-fav]');
    if (!btn) return;
    event.preventDefault();

    var handle = btn.getAttribute('data-jo-fav');
    var saved = toggle(handle);

    // The same product can be on the page more than once (a slider and a
    // grid, say), so every button for it changes together.
    document.querySelectorAll('[data-jo-fav]').forEach(function (other) {
      if (other.getAttribute('data-jo-fav') === handle) paintButton(other);
    });

    if (saved) {
      btn.classList.remove('is-popping');
      void btn.offsetWidth; // restart the animation on quick repeat taps
      btn.classList.add('is-popping');
    }
  });

  // The animation runs on the icon inside the button.
  document.addEventListener('animationend', function (event) {
    var popping = event.target.closest && event.target.closest('.is-popping');
    if (popping) popping.classList.remove('is-popping');
  });

  new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.hasAttribute('data-jo-fav')) paintButton(node);
        else paintAll(node);
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });

  // Saved in another tab, or this page restored from the back/forward cache.
  window.addEventListener('storage', function (event) {
    if (event.key === KEY) paintAll();
  });
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) paintAll();
  });

  // Exposed so the favourites page can read the same list.
  window.JoFavorites = { read: read, has: has, toggle: toggle, refresh: paintAll };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { paintAll(); }, { once: true });
  } else {
    paintAll();
  }
})();
